export default __webpack_public_path__ + "static/media/GenericUserIcon.260d988a.svg";